import { render, staticRenderFns } from "./ReadFamilia.vue?vue&type=template&id=22dbfb40"
import script from "./ReadFamilia.vue?vue&type=script&lang=js"
export * from "./ReadFamilia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports